import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Dashboard from '@/components/pages/Dashboard'
import Summary from '@/components/pages/Summary'
import Incomes from '@/components/pages/Incomes'
import Daily from '@/components/pages/Daily'
import Test from '@/components/pages/Test'
import Arrival from '@/components/pages/Arrival'
import Departure from '@/components/pages/Departure'
import WorldMap from '@/components/pages/worldmap'
import Perron from '@/components/pages/Perron'
import TrackingMap from '@/components/pages/TrackingMap'
import Err404 from '@/components/pages/404'
import Permission from '@/components/pages/AccessDenied'
import Control from '@/components/pages/Control'

Vue.use(Router)

/*
 * Проверка прав доступа при переходе к модулю
 */
const checkAccess = (to, from, next) => {
  let user = store.getters['getUser']
  let access = store.getters['chechAccess'](to.name)
  if (user.loggedInStatus && !access) {
    next('/permission')
  } else {
    next()
  }
  return true
}

const R = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/summary',
      name: 'summary',
      beforeEnter: checkAccess,
      component: Summary,
    },
    {
      path: '/incomes',
      name: 'charges',
      beforeEnter: checkAccess,
      component: Incomes,
    },
    {
      path: '/daily',
      name: 'daily',
      beforeEnter: checkAccess,
      component: Daily,
    },
    {
      path: '/arrival',
      name: 'arrival',
      beforeEnter: checkAccess,
      component: Arrival,
    },
    {
      path: '/departure',
      name: 'departure',
      beforeEnter: checkAccess,
      component: Departure,
    },
    {
      path: '/worldmap',
      name: 'wm',
      beforeEnter: checkAccess,
      component: WorldMap,
    },
    {
      path: '/perron',
      name: 'ap',
      beforeEnter: checkAccess,
      component: Perron,
    },
    {
      path: '/trackingmap',
      name: 'tm',
      beforeEnter: checkAccess,
      component: TrackingMap,
    },
    {
      path: '/control',
      name: 'control',
      component: Control,
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
    },
    {
      path: '/permission',
      name: 'Permission',
      component: Permission,
    },
    {
      path: '/*',
      name: 'Error404',
      component: Err404,
    },
  ],
})

R.beforeEach(async function(to, from, next) {
  store.dispatch('checkLocalUser')
  next()
})

export default R
